module.exports = __webpack_public_path__ + "img/contact_img.1d7d6375.svg";